var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('preloginheader'),_c('preloginMain',{on:{"openbottomsheet":function($event){_vm.AppDialog = true}}}),(_vm.$vuetify.breakpoint.width < 600)?_c('preloginbottomsheet',{attrs:{"appDialog":_vm.AppDialog},on:{"closeAppDialog":function($event){_vm.AppDialog = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }